import React from "react";
import BlogPostCard from "../BlogPostCard/BlogPostCard";
// Import the styles object for the list container
import styles from "./BlogList.module.css";
import Navigation from "../navigation/navigation";

function BlogList({ posts }) {
  return (
    <>
      <Navigation />
      <div className={styles.listContainer}>
        <h2 className={styles.header}>Recent Blog Posts</h2>
        <div className={styles.grid}>
          {posts.map((post) => (
            <BlogPostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </>
  );
}

export default BlogList;
